// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as FormInputModuleScss from "../styles/common/FormInput.module.scss";

var styles = FormInputModuleScss;

function FormInputCmp(Props) {
  var label = Props.label;
  var is_required = Props.is_required;
  var children = Props.children;
  var error = Props.error;
  var classNameOpt = Props.className;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement("div", {
              className: "" + styles.container + " " + className + ""
            }, React.createElement("div", {
                  className: styles["input-container"]
                }, React.createElement("label", {
                      className: "" + (
                        is_required ? styles["label-required"] : styles.label
                      ) + " \n            " + (
                        Belt_Option.isSome(error) ? styles.error : ""
                      ) + "",
                      htmlFor: label
                    }, label), children), error !== undefined ? React.createElement("div", {
                    className: styles["error-container"]
                  }, error) : null);
}

var str = "../styles/common/FormInput.module.scss";

var make = FormInputCmp;

export {
  str ,
  styles ,
  make ,
}
/* styles Not a pure module */
